module.exports = __webpack_public_path__ + "1791188489487/fonts/Flaticon.bb9d9c1.eot";